module.exports = require("ramda/src/pipe");